import { FC } from "react";
import styles from "./Social.module.scss";
import classNames from "classnames";
import { ReactComponent as PhoneRoundIcon } from "../../../icons/telehoneRound.svg";
import { ReactComponent as DialogRoundIcon } from "../../../icons/message.svg";

interface SocialProps {
  classess?: string;
}

const Social: FC<SocialProps> = ({ classess }) => {
  return (
    <div className={classNames(styles.Social, {}, [classess])}>
      <a href="tel:89222137555">
        <PhoneRoundIcon />
      </a>
      <a href="mailto:kokotkina_2013@mail.ru">
        <DialogRoundIcon />
      </a>
    </div>
  );
};

export default Social;
